export default __webpack_public_path__ + "static/media/(91).6063b42d.jpg";